export default __webpack_public_path__ + "b1c32aa57ad5bc9998dddd0131296064.ttf";